import { KPICardItem } from './Helpers/KPICard/KPICardContainer';

export interface FilterOptions {
  event_type: string[];
  federation_name: string[];
  distributor_count: number[];
  adserver_type: string[];
  audience_transferred: string[];
  start_date: string[];
  end_date: string[];
}

export const filterOptions: FilterOptions = {
  event_type: ['Query', 'Engaged', 'Audience Transferred', 'Deleted', 'Persisted'],
  federation_name: ['Fed A', 'Fed B', 'Fed C'],
  distributor_count: [100, 200, 300],
  adserver_type: ['Other', 'AdServer'],
  audience_transferred: ['Other', 'Audience'],
  start_date: [],
  end_date: [],
};

export const KPICardData: KPICardItem[] = [
  { value: '0', title: 'Federations',          accentColor: 'var(--Primary-Color-Shade-1)', iconType: 'federation', tooltip: 'Counts only federations that recorded at least one transaction within the selected period.' },
  { value: '0', title: 'Queries Executed',      accentColor: '#10B981', iconType: 'queries',    tooltip: 'This count includes all queries your organisation ran, plus queries run by others where your data was used.' },
  { value: '0', title: 'Queries Engaged',       accentColor: '#F59E0B', iconType: 'engaged',    tooltip: 'Queries where a matching audience record was found and actioned — e.g. transferred or activated.' },
  { value: '0', title: 'Profiles Queried',      accentColor: '#10B981', tooltip: 'Total number of audience profiles queried across all events in the selected period.' },
  { value: '0', title: 'Profiles Engaged',               accentColor: '#F59E0B', tooltip: 'Total audience profiles that were matched and engaged during the selected period.' },
  { value: '0', title: 'Profiles Transferred',  accentColor: '#8B5CF6', iconType: 'transfer',   tooltip: 'Total audience records transferred across all federations in the selected period.' },
];
